// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-box:hover {
  opacity: 0.9;
}

.drag-div {
  background-color: #fff;
  color: #000;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 7px 6px 7px 6px;
  display: flex;
  flex-direction: row;
  text-align: start;
  margin-top: 5px;
  gap: 5px;
  font-size: 12px;
}

@media (min-width: 1024px) {
  .drag-div {
    font-size: 11px;
  }
}
@media (min-width: 1366px) {
  .drag-div {
    font-size: 13px;
  }
}
@media (min-width: 1920px) {
  .drag-div {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/components/formbuilder/DraggableBox.scss"],"names":[],"mappings":"AAAE;EACE,YAAA;AACJ;;AAEE;EACE,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,wBAAA;EAEA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAAJ;;AAIA;EACE;IACE,eAAA;EADF;AACF;AAIA;EACE;IACE,eAAA;EAFF;AACF;AAKA;EACE;IACE,eAAA;EAHF;AACF","sourcesContent":["  .drag-box:hover {\n    opacity: 0.9;\n  }\n  \n  .drag-div {\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 7px 6px 7px 6px;\n\n    display: flex;\n    flex-direction: row;\n    text-align: start;\n    margin-top: 5px;\n    gap: 5px;\n    font-size: 12px;\n  }\n\n// Laptop\n@media (min-width: 1024px) {\n  .drag-div {\n    font-size: 11px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .drag-div {\n    font-size: 13px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .drag-div {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
